import PayTip from '@/components/common/payTip.vue';
// import Footer from '@/components/common/Footer.vue'
import { meetReq } from '@/api/index';
import { defineComponent } from 'vue';
import BackBtn from '@com/common/BackBtn.vue';
import { callPhone, appPort, iOSPort, userLogin, getUserId, isLogin, weixinShare } from '@/widget/index';
export default defineComponent({
    data() {
        return {
            detail: {},
            isApp: appPort(),
            orderInfo: {},
            iOS: iOSPort(),
            userId: getUserId(),
            loaded: false,
            btnImg: ''
        };
    },
    computed: {
        btnText() {
            if (this.isApp) {
                return this.detail.isPay ? '去练习' : '立即报名';
            }
            else {
                return this.detail.isPay ? '请打开【好医术】APP练习' : '立即报名';
            }
        }
    },
    methods: {
        getGuide() {
            this.$store.commit('SET_PAYTIP', false);
            meetReq.getExerciseGuide({
                userId: this.userId
            }, {
                depId: this.$route.query.depId || ''
            }).then(res => {
                this.loaded = true;
                if (res.code === 200) {
                    this.detail = res.data;
                    let shareInfo = res.data.share || '';
                    this.btnImg = res.data.bottomImage;
                    shareInfo && weixinShare({
                        title: shareInfo.title,
                        url: shareInfo.url,
                        desc: shareInfo.desc,
                        image: shareInfo.image
                    });
                }
                else {
                    this.$toast(res.message);
                }
            });
        },
        apply() {
            if (isLogin) {
                // TODO 无限购买
                // if (this.detail.isPay) {
                //   if (this.isApp) {
                //     jumpModuleApp({
                //       typeId: 'exercise_home',
                //       dataId: 0,
                //       type: 'INDIVIDUAL'
                //     })
                //   } else {
                //     window.open('https://datayi.cn/bLbjaaidWmmO')
                //   }
                //   return;
                // }
                // 创建订单
                this.$showLoading();
                meetReq.createExerciseOrder({
                    userId: this.userId
                }, {
                    depId: this.$route.query.depId || '',
                    sourceId: this.$route.query.sourceId || '0'
                }).then(res => {
                    if (res.code === 200) {
                        // 获取订单信息
                        this.getExerciseOrderInfo(res.data);
                    }
                    else {
                        this.$hideLoading();
                        this.$toast(res.message);
                    }
                });
            }
            else {
                userLogin();
            }
        },
        getExerciseOrderInfo(id) {
            meetReq.getExerciseOrderInfo({
                orderId: id
            }).then(res => {
                this.$hideLoading();
                if (res.code === 200) {
                    this.$store.commit('SET_PAYTIP', true);
                    this.orderInfo = res.data;
                }
                else {
                    this.$toast(res.message);
                }
            });
        },
        service(tel) {
            callPhone(tel);
        },
        payCallBack() {
            // let sourceId = this.$route.query.sourceId;
            // if (/^190\d{6}/.test(sourceId) || /^200\d{6}/.test(sourceId)) {
            //   // 分享页进入支付成功后进入列表页
            //   this.$router.replace({
            //     name: 'learnListExercise',
            //     query: {
            //       depId: this.$route.query.depId || ""
            //     }
            //   })
            // } else {
            //   this.getGuide()
            // }
            this.$router.replace({
                name: 'learnListExercise',
                query: {
                    depId: this.$route.query.depId || ""
                }
            });
        }
    },
    mounted() {
        this.getGuide();
    },
    components: {
        PayTip,
        BackBtn
    }
});
